import React, { useEffect } from "react";
import { usePreloader, withPreloading } from "../../../HOC/withPreloading/withPreloading";
import { useStore } from "../../../../models";
import { ProfileSettings } from "../profileSettings";
import { LoadingState } from "../../../HOC/withPreloading/types";

const MyProfileSettingsComponent = () => {
  const { currentUserStore } = useStore();
  const { setLoadingState } = usePreloader();

  useEffect(() => {
    const loadProfileData = async () => {
      await currentUserStore.loadProfileData();
      setLoadingState(LoadingState.Loaded);
    };

    loadProfileData();
  }, []);

  if (!currentUserStore.profile) {
    return <></>;
  }

  return <ProfileSettings userProfile={currentUserStore.profile} />;
};

export const MyProfileSettings = withPreloading(MyProfileSettingsComponent);
